import { render, staticRenderFns } from "./TicketStatusChangeModal.vue?vue&type=template&id=4e23f2a8&scoped=true"
import script from "./TicketStatusChangeModal.vue?vue&type=script&lang=js"
export * from "./TicketStatusChangeModal.vue?vue&type=script&lang=js"
import style0 from "./TicketStatusChangeModal.vue?vue&type=style&index=0&id=4e23f2a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e23f2a8",
  null
  
)

export default component.exports